// Adaptación de tu App.tsx con protección de carga de traducciones

import '@refinedev/antd/dist/reset.css';
import './App.scss';

import {
  CreditCardOutlined,
  DeploymentUnitOutlined,
  PartitionOutlined,
  TagOutlined,
  TruckFilled,
  TruckOutlined,
  UnorderedListOutlined,
  WalletOutlined,
} from '@ant-design/icons';
import { ResourceProps } from '@refinedev/core';

export const REFINE_RESOURCES: ResourceProps[] = [
  {
    name: 'tickets',
    list: '/tickets',
    create: '/tickets/create',
    edit: '/tickets/edit/:id',
    show: '/tickets/show/:id',
    meta: {
      canDelete: true,
      icon: <UnorderedListOutlined />,
      label: 'Tickets',
    },
  },
  {
    name: 'logistics',
    meta: { label: 'Logística', icon: <DeploymentUnitOutlined /> },
  },

  {
    name: 'shipments',
    list: '/shipments',
    create: '/shipments/create',
    edit: '/shipments/edit/:id',
    show: '/shipments/show/:id',
    meta: {
      canDelete: true,
      icon: <TruckOutlined />,
      label: 'Envíos',
      parent: 'logistics',
    },
  },
  {
    name: 'receptions',
    list: '/receptions',
    create: '/receptions/create',
    edit: '/receptions/edit/:id',
    show: '/receptions/show/:id',
    meta: {
      canDelete: true,
      icon: <TruckFilled />,
      label: 'Recepciones',
      parent: 'logistics',
    },
  },
  {
    name: 'shipping_labels',
    list: '/shipping_labels',
    create: '/shipping_labels/create',
    edit: '/shipping_labels/edit/:id',
    show: '/shipping_labels/show/:id',
    meta: {
      canDelete: true,
      icon: <TagOutlined />,
      label: 'Direcciones de envío',
      parent: 'logistics',
    },
  },
  {
    name: 'shippers',
    list: '/shippers',
    create: '/shippers/create',
    edit: '/shippers/edit/:id',
    show: '/shippers/show/:id',
    meta: {
      canDelete: true,
      icon: <TruckFilled />,
      label: 'Operadores logísticos',
      parent: 'logistics',
    },
  },
  {
    name: 'administration',
    meta: { label: 'Administración', icon: <WalletOutlined /> },
  },
  {
    name: 'spare-parts-collections',
    list: '/spare-parts-collections',
    show: '/spare-parts-collections/:id',
    meta: {
      canDelete: true,
      icon: <CreditCardOutlined />,
      label: 'Cobranzas de repuestos',
      parent: 'administration',
    },
  },
  {
    name: 'service_orders',
    list: '/service_orders',
    show: '/service_orders/show/:id',
    create: '/service_orders/create',
    edit: '/service_orders/edit/:id',
    meta: { canDelete: true, label: 'Órdenes de servicio', icon: <CreditCardOutlined /> },
  },
  {
    name: 'case-resolution',
    list: '/case-resolution',
    show: '/case-resolution/:id',
    meta: {
      canDelete: true,
      icon: <PartitionOutlined />,
      label: 'Resolución de casos',
    },
  },
];

/**
 * Recursos implementados en la aplicación.
 * Usado para tipar permisos y otros aspectos relacionados con recursos.
 */
export enum RESOURCES {
  TICKETS = 'tickets',
  SHIPMENTS = 'shipments',
  RECEPTIONS = 'receptions',
  CASE_RESOLUTION = 'case-resolution',
  SPARE_PARTS_COLLECTIONS = 'spare-parts-collections',
  SHIPPING_LABELS = 'shipping_labels',
  SHIPPERS = 'shippers',
  SERVICE_ORDERS = 'service_orders',
}
